<template>
  <div class="grid grid-cols-3 gap-4 contentArea">
    <div>
      <button @click="$router.go(-1)" class="back-btn">
        <img src="@/assets/images/elements/turnback.svg" />
        กลับ
      </button>
      <div class="h-full lecturer-card mt-5">
        <div class="mt-5 Profile-pic">
          <img
            v-if="page.Detail.img_url"
            :src="page.Detail.img_url"
            class="object-cover h-full w-full"
          />
          <img
            v-show="!page.Detail.img_url"
            class="h-full pic-style"
            src="@/assets/images/logo/ProfileFA.svg"
          />
        </div>
        <div class="w-full m-5">
          <div class="grid grid-cols-3 gap-4 w-full my-3 ">
            <div class="flex justify-end">ชื่อ</div>
            <div class="col-span-2 break-words">
              {{ page.Detail.first_name }}
            </div>
          </div>
          <span class="grid grid-cols-3  gap-4 w-full my-3">
            <span class="flex justify-end">อีเมล</span>
            <span class="col-span-2 break-words">{{ page.Detail.email }}</span>
          </span>
          <span class="grid grid-cols-3  gap-4 w-full my-3">
            <span class="flex justify-end">เบอร์ติดต่อ</span>
            <span class="col-span-2 break-words">{{ page.Detail.phone }}</span>
          </span>
          <span class="grid grid-cols-3  gap-4 w-full my-3">
            <span class="flex justify-end">รายละเอียด</span>
            <span class="col-span-2 break-words">{{ page.Detail.detail }}</span>
          </span>
        </div>
      </div>
    </div>
    <AgGrid class="col-span-2" />
  </div>
</template>

<script>
import AgGrid from "@/views/elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.$store.dispatch(
        "general/getLecturerDetail",
        this.$route.params.id
      );
    });
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue && !this.is_load) {
        this.$store.dispatch(
          "general/getLecturerDetail",
          this.$route.params.id
        );
        this.is_load = true;
      }
    }
  },

  computed: {
    ...mapGetters({
      page: "general/page"
    })
  },
  data() {
    return {
      is_load: false
    };
  }
};
</script>

<style lang="scss" scoped>
.lecturer-card {
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #305eb3;
}
.Profile-pic {
  border-radius: 50%;
  border-style: none;
  box-shadow: inset rgba(0, 0, 0, 0.19) 0px 5px 5px;
  overflow: hidden;
  background-color: white;
  height: 150px;
  width: 150px;
}
.pic-style {
  display: inline;
  margin: 0 auto;
  height: 100%;
  width: auto;
  object-fit: cover;
}
.back-btn {
  background: none !important;
  border: none;
  &:hover {
    transition: 10ms;
    padding-left: 10px;
  }
}
</style>
